import { action, makeObservable } from 'mobx';
import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { userStatusService } from '../domain';
import { Link } from '../lib/components';
import { routes } from './Routes';
import { useTranslation } from 'react-i18next';
import { ChangeLanguage } from 'lib/components/ChangeLanguage';

export function HeaderBlock() {
  const { t } = useTranslation();

  function logout() {
    userStatusService.setLoggedOut();
  }

  return (
    <div className="header-block">
      <div className="header-title">
        {t('header.title')}
      </div>
      <div className="header-right">
        <ul>
          <li>
          <ChangeLanguage></ChangeLanguage>
          </li>
          <li className="header-search">
            <p style={{ marginBlock: 'auto' }}>
              <button type="submit"><i className="fas fa-search"></i></button>
              <input type="text" placeholder={t('header.search-placeholder')} />
            </p>
          </li>
          <li className="header-message">
            <a href="#msg">
              <i className="far fa-bell"></i>
              <span>12</span>
            </a>
          </li>

          <UncontrolledButtonDropdown className="user-dropdown" group={false}>
            <DropdownToggle tag="div" className="user-dropdown-toggle">
              <i className="far fa-user-circle"></i>
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem tag={Link} to={routes.CurrentUser}>
                <i className="fas fa-user-cog" /> {t('header.profile')}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={action(logout)}>
                <i className="fas fa-sign-out-alt" /> {t('header.logout')}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </ul>
      </div>
    </div>
  );
}
